import { ImageItem } from "../../../../domain/document/items";
import { BeanTypes, IImageItemBean } from "../beans/items";
import { AbstractImageItemTranslator } from "./AbstractImageItemTranslator";

export class ImageItemTranslator extends AbstractImageItemTranslator<ImageItem, IImageItemBean> {
  constructor(getToken: () => string) {
    super(getToken, BeanTypes.Image);
  }

  protected craeteItem(): ImageItem {
    return new ImageItem();
  }
}
